import React, { Fragment } from 'react'
import { Breadcrumbs, UL } from '../../../AbstractElements';
import DataGridInvoiceWiseView from './DataGridInvoiceWiseView';
import { Container } from 'reactstrap';

const UATInvoiceGrid = () => {
    if (localStorage.getItem("usertype") !== "Backend User") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    return (
        <UL attrUL={{ className: 'simple-list nav-menus flex-row' }}>
            <Fragment>
                <Breadcrumbs parent="Invoice Grid - UAT" title="Invoice Grid - UAT" mainTitle="Invoice Grid - UAT" />
                <Container fluid={true}>
                    <DataGridInvoiceWiseView source="uat" />
                </Container>
            </Fragment>
        </UL>
    )
}

export default UATInvoiceGrid
